<template lang="pug">
div(
  :key="mounted"
  @click="$refs.uploader.click()"
  @drop.stop.prevent="drop"
  @dragenter.stop.prevent="dragEnter"
  @dragleave.stop.prevent="dragLeave"
  @dragover.prevent
)
  input(
    ref="uploader"
    style="display:none;"
    :accept="acceptFiles"
    @change="selectFile"
    type="file"
    v-bind="$attrs"
  )
  slot(name="activator" v-bind="{ loading }")
    v-btn( color="primary")
      | Выберите файл
      v-icon mdi-attachment

</template>

<script>
/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
import { apiService } from '@/services/APIService';

export default {
  name: 'Uploader',
  props: {
    accept: { type: String, requierd: false, default: 'all' },
  },
  data() {
    return {
      file: '',
      original_name: '',
      mounted:false,

      loading: false,

      isDragging: false,
      dragCount: 0,
    };
  },
  computed: {
    acceptFiles() {
      if (this.accept === 'all') {
        return 'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
      if (this.accept === 'image') {
        return 'image/*';
      }
      return 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    },
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    async selectFile() {
      const file = this.$refs.uploader.files[0];
      if (!file) {
        this.file = '';
        return;
      }

      this.loading = true;
      await this.uploadFile(file);
      this.loading = false;
    },
    /**
     * Загружает файл на сервер, возвращает имя файла
     * @returns {Promise<unknown>}
     */
    async uploadFile(file) {
      return new Promise((resolve) => {
        if (!file) {
          resolve(null);
          return;
        }

        const CHUNK_SIZE = 500 * 1024;
        const fileSize = file.size;
        this.original_name = file.name;

        // ADD Single upload
        this.uploadChunked(file, resolve, CHUNK_SIZE, fileSize);
      });
    },

    async uploadChunked(file, resolve, chunkSize, fileSize) {
      const dispositionName = Math.random().toString(32);
      // const chunksCount = Math.ceil(fileSize / chunkSize);

      let response;
      for (let start = 0; start < fileSize; start += chunkSize) {
        const data = new FormData();
        data.append(
          'file',
          file.slice(start, start + chunkSize),
          dispositionName,
        );

        response = await  apiService.post('/uploads', data, {
          headers: {
            'Content-Type': 'application/octet-stream',
            'Accept': 'application/json',
            'Content-Disposition': `attachment; filename=${dispositionName}`,
            'Content-Range': `bytes ${start}-${start + chunkSize}/${fileSize}`,
          },
        });
        // this.progress += Math.ceil(100 / chunksCount);
      }
      resolve();
      this.$emit('upload', {
        ...response.data.data,
        original_name: this.original_name,
      });
    },

    // Dragging
    dragEnter() {
      this.dragCount += 1;
      this.$emit('dragging', true);
      this.isDragging = true;
    },

    dragLeave() {
      this.dragCount -= 1;
      if (this.dragCount <= 0) {
        this.$emit('dragging', false);
        this.isDragging = false;
      }
    },

    drop(event) {
      this.dragCount = 0;
      this.$emit('dragging', false);
      const { files } = event.dataTransfer;

      if ((files || []).length) {
        files.forEach((file) => this.uploadFile(file));
      }
    },
  },
};
</script>
